<template>
	<div style="display: inline-block">
		<el-switch :value="value" v-bind="$props" @change="change" :activeValue="activeValue" :inactiveValue="inactiveValue">
		</el-switch>
		<!-- <span v-else>{{value===activeValue?'启用':'禁用'}}</span> -->
	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			activeText: {
				default: () => {
					return '是'
				}
			},		
			inactiveText: {
				default: () => {
					return '否'
				}
			},
			activeValue	: {
				default: () => {
					return 1
				}
			},
			inactiveValue: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				value1: 0
			}
		},
		created() {


		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
				this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
			},
		}
	}
</script>
<style scope>
	.el-form-item__content {
		line-height: 34px;
	}
</style>
